// ./src/components/generic/StatusBadge/StatusBadge.tsx
import React from "react";
import { Badge, MantineColor } from "@mantine/core";
import { STATUSES } from "@sdflc/utils";

// ============================================
// Types
// ============================================

export interface StatusBadgeProps {
  /** Status code: -1 = Unknown, 0 = Disabled, 50 = Pending, 100 = Active */
  status?: number | null | undefined;
  /** Size of the badge */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

interface StatusConfig {
  label: string;
  color: MantineColor;
}

// ============================================
// Status Configuration
// ============================================

const STATUS_CONFIG: Record<number, StatusConfig> = {
  "-1": { label: "Unknown", color: "neutral" },
  [STATUSES.DISABLED]: { label: "Disabled", color: "gray" },
  [STATUSES.DRAFT]: { label: "Draft", color: "gray" },
  [STATUSES.PENDING]: { label: "Pending Approval", color: "warning" },
  [STATUSES.BLOCKED]: { label: "Blocked", color: "danger" },
  [STATUSES.ACTIVE]: { label: "Active", color: "success" },
  [STATUSES.REMOVED]: { label: "Removed", color: "danger" },
};

const DEFAULT_STATUS: StatusConfig = STATUS_CONFIG[-1];

// ============================================
// Component
// ============================================

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = "sm",
}) => {
  const statusKey = status ?? -1;
  const config = STATUS_CONFIG[statusKey] ?? DEFAULT_STATUS;

  return (
    <Badge color={config.color} variant="light" size={size} radius="sm">
      {config.label}
    </Badge>
  );
};
